//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { FAQ } from '@/containers-latam/FAQ';

//containers
import {
  Hero,
  WatchItRunYourFreight,
  HowItWorks,
  RunsOnYourStack,
  TheRestOfTheLineup,
  EndCTA,
} from '../containers';

//styles
import {
  PageWrapper,
  TenderFailuresGlobalStyle,
} from './TenderFailures.styles';

function TenderFailures({ content, nav, footer, faqContent }) {
  return (
    <PageWrapper>
      <TenderFailuresGlobalStyle />
      <Navigation theme="dark" nav={nav} />
      <Hero {...content.hero} shared={content.agentsShared.hero} />
      <WatchItRunYourFreight
        {...content.watchItRun}
        shared={content.agentsShared.watchItRunYourFreight}
      />
      <HowItWorks
        {...content.howItWorks}
        shared={content.agentsShared.howItWorks}
      />
      <RunsOnYourStack content={content.agentsShared.runsOnYourStack} />
      <TheRestOfTheLineup
        cards={content.lineupCards}
        content={content.agentsShared.theRestOfTheLineup}
      />
      {faqContent && <FAQ content={faqContent} />}
      <EndCTA
        agentName={content.hero.title}
        content={content.agentsShared.endCta}
      />
      <Footer config={footer} />
    </PageWrapper>
  );
}

export default TenderFailures;
export { TenderFailures };
